"use client";
import React, { memo } from "react";
import { Tabs, TabsProps } from "@mui/material";

const CommonTabs = ({ children, sx, ...otherProps }: TabsProps) => {
  return (
    <Tabs
      sx={{
        minHeight: "40px",
        "& .MuiTabs-flexContainer": {
          height: "100%",
        },
        ...sx,
      }}
      {...otherProps}
    >
      {children}
    </Tabs>
  );
};

export default memo(CommonTabs);
